import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';

export const SCard = styled.div.attrs({ className: 'mb-5' })`
  position: relative;
  //border: 1px solid red;
  max-width: 500px;
  margin: 0 auto;
  overflow: hidden;
`;

export const SName = styled.div`
  color: white;
  font-size: ${calcResize(24, 32)};
  margin: 20px 0 0 0;
`;

export const SJobTitle = styled.div`
  color: ${props => props.theme.colors.accent};
  font-size: ${calcResize(16, 20)};
  margin: 0 0 20px 0;
`;

export const SDescription = styled.div`
  color: white;
  margin: 0 0 25px;
`;
